document.addEventListener('DOMContentLoaded', function() {
  //product-form
  let productContainer = document.getElementById('product-recommended-size');
  let allSpecs = document.querySelectorAll('.product-form__option-value')
  let selectorSpecs = document.querySelectorAll('.product-form__option-selector');
  let lastSelectorSpecs = selectorSpecs[selectorSpecs.length -1];
  let blockSwatchElements = lastSelectorSpecs.querySelectorAll('.block-swatch');
  blockSwatchElements.forEach(function(element,index) {
      let elementInput = element.querySelector('input[type="radio"]');
      let block = element.querySelector('.product-size-content');

      let sizeElementHeight = element.offsetHeight;
      let sizeDesHeight = block.offsetHeight;
      let leftWindt = (window.innerWidth - productContainer.offsetWidth) / 2;
      if(elementInput.checked && window.innerWidth < 1000){
        let option = element.querySelector(`input[name="option${selectorSpecs.length}"]`).value;
        sizeListFunc(allSpecs,option).then(res =>{
            let metaobjectText = element.querySelector('.metaobjectText')
            metaobjectText.innerHTML = res;
            block.style.display = "block" 
            let arrowImg = element.querySelector('.arrow-img');
            arrowImg.style.left = (element.offsetWidth / 2) - 5 + 'px';
            block.style.marginLeft = -(element.getBoundingClientRect().left - leftWindt) + 'px';
            block.style.width = (productContainer.offsetWidth) + 'px';
            console.log(block.offsetHeight,element.offsetHeight)
            element.style.height  = (block.offsetHeight + 49) + 'px';
        }) 
      }
      element.addEventListener('mouseenter', function() {
          if (window.innerWidth >= 1000) {
            let option = element.querySelector(`input[name="option${selectorSpecs.length}"]`).value;
            sizeListFunc(allSpecs,option).then(res =>{
              let metaobjectText = element.querySelector('.metaobjectText')
              metaobjectText.innerHTML = res;
              block.style.display = "block"
            })
          }
      });
      element.addEventListener('mouseleave', function() {
          if (window.innerWidth >= 1000) {
             block.style.display = "none"
          }
      });
      element.addEventListener('click', function() {
          if (window.innerWidth < 1000) {
             blockSwatchElements.forEach(function(item,bix) {
               let itemInput = item.querySelector('input[type="radio"]');
               let blocks = item.querySelector('.product-size-content');
               if(bix != index){
                 blocks.style.display = "none"
                 item.style.height = sizeElementHeight+ 'px';
               }
               if(bix == index && !itemInput.checked){
                  let option = element.querySelector(`input[name="option${selectorSpecs.length}"]`).value;
                  sizeListFunc(allSpecs,option).then(res =>{
                    let metaobjectText = element.querySelector('.metaobjectText')
                    metaobjectText.innerHTML = res;
                    blocks.style.display = "block"
                    let arrowImg = element.querySelector('.arrow-img');
                    arrowImg.style.left = (element.offsetWidth / 2) - 5 + 'px';
                    blocks.style.marginLeft = -(element.getBoundingClientRect().left - leftWindt) + 'px';
                    blocks.style.width = (productContainer.offsetWidth) + 'px';
                    item.style.height  = (blocks.offsetHeight + 49) + 'px';
                  }) 
               }
              })
          }else{
            block.style.display = "none"
          }
      });
  });
  function sizeListFunc(allSpecs,option){
    let metaobjectList = document.getElementById('metaobjectList');
    let sizeList = metaobjectList.querySelectorAll('.sizeList')
    return new Promise((resolve) => {
      if(!sizeList.length > 0){ return false } //元对象没有时不执行下列条件
      let innerText1 = [];
      let specs = [];
      allSpecs.forEach((item,index) =>{ specs.push(item.innerHTML) }) //已选规格遍历
      if(specs.length > 1){ //符合2层以上规格
          sizeList.forEach((list,idx) =>{ //元对象遍历
            let option1 = list.getAttribute('data-option1') || '';
            let option2 = list.getAttribute('data-option2') || '';
            let option3 = list.getAttribute('data-option3') || '';   
            if(specs.length == 2 && specs[0] == option1 && option == option2){
               innerText1 = ArrayMetaobject(list,innerText1)
            }else if(specs.length == 3 && specs[0] == option1 && specs[1] == option2 && option == option3){
               innerText1 = ArrayMetaobject(list,innerText1)
            }
          })
      }else{ //只有1层规格
         sizeList.forEach((list,idx) =>{
             let option1 = list.getAttribute('data-option1') || '';
             if(option == option1){
                innerText1 = ArrayMetaobject(list,innerText1)
             }
        })
      }
      let innerText = innerText1.join('<br>') || '';
      if(innerText){
        resolve(innerText)
      }
    })
  }
  
  //product-sticky-form
  let productContainerDown = document.getElementById('product-sticky-form__form');
  let productDownList = document.querySelectorAll('.select-wrapper');
  let allSticky = document.querySelectorAll('.select__selected-value')
  let productDownListLength = productDownList[productDownList.length -1];
  let productSizeButtons = productDownListLength.querySelectorAll('.combo-box__option-item');
  productSizeButtons.forEach(function(element) {
      element.addEventListener('mouseenter', function() {
          let block = element.querySelector('.product-size-item-bottom');
          let option = element.value;
          sizeListFunc(allSticky,option).then(res =>{
            let metaobjectText = element.querySelector('.metaobjectText')
            metaobjectText.innerHTML = res;
            block.style.display = "block"
          })
      });
      element.addEventListener('mouseleave', function() {
          let block = element.querySelector('.product-size-item-bottom');
          block.style.display = "none"
      });
      element.addEventListener('click', function() {
          let block = element.querySelector('.product-size-item-bottom');
          block.style.display = "none"
      });
  });
  function sizeListFunc(allSticky,option){
    let metaobjectList = document.getElementById('metaobjectList');
    let sizeList = metaobjectList.querySelectorAll('.sizeList')
    return new Promise((resolve) => {
      if(!sizeList.length > 0){ return false } //元对象没有时不执行下列条件
      let innerText1 = [];
      let specs = [];
      allSticky.forEach((item,index) =>{ 
         let ariaLabelValue = item.querySelector('.select__color-swatch');
         if(ariaLabelValue){
            specs.push(ariaLabelValue.getAttribute('aria-label'))
          }else{
            specs.push(item.innerHTML)
          }
      }) //已选规格遍历
      if(specs.length > 1){ //符合2层以上规格
          sizeList.forEach((list,idx) =>{ //元对象遍历
            let option1 = list.getAttribute('data-option1') || '';
            let option2 = list.getAttribute('data-option2') || '';
            let option3 = list.getAttribute('data-option3') || '';   
            if(specs.length == 2 && specs[0] == option1 && option == option2){
               innerText1 = ArrayMetaobject(list,innerText1)
            }else if(specs.length == 3 && specs[0] == option1 && specs[1] == option2 && option == option3){
               innerText1 = ArrayMetaobject(list,innerText1)
            }
          })
      }else{ //只有1层规格
         sizeList.forEach((list,idx) =>{
             let option1 = list.getAttribute('data-option1') || '';
             if(option == option1){
                innerText1 = ArrayMetaobject(list,innerText1)
             }
        })
      }
      let innerText = innerText1.join('<br>') || '';
      if(innerText){
        resolve(innerText)
      }
    })
  }
  
  //符合对象赋值到数组中，进行排序
  function ArrayMetaobject(list,innerText1){
      let nameEdit = list.innerHTML;
      if(nameEdit.startsWith("_recommended_dog_breeds")){
        innerText1.push(list.innerHTML.replace("_recommended_dog_breeds", "Best suit for: "));
      }
      if(nameEdit.startsWith("_recommended_weight")){
        innerText1.unshift(list.innerHTML.replace("_recommended_weight", "Pet's weight "));
      }
      if(nameEdit.startsWith("_specification_size")){
        innerText1.unshift(list.innerHTML.replace("_specification_size", "Size: "));
      }
      return innerText1
  }
}) 